import {AboutFormProps} from "../../../../types";
import {Form, Input, Spin, Switch, UploadFile} from "antd";
import {VALIDATION_MESSAGES} from "../../../../../../enums/validationMessages";
import TextEditor from "../../../../../../components/text-editor/TextEditor";
import Uploader from "../../../../../../components/uploader/Uploader";
import * as BUCKETS from "../../../../../../enums/buckets";
import "./style.less"
import {ReactNode, useEffect, useState} from "react";
import {getImageLink, showErrorNotification} from "../../../../../../helpers/mainHelpers";
import {AboutItem} from "../../../../../../types/about";

const AboutForm = (props: AboutFormProps) => {
  const {form, submitButtonHandler, isLoading, selectedAboutItem} = props.aboutController
  const [uploadImages, setUploadImages] = useState<UploadFile[]>([])
  const [mainImageId, setMainImageId] = useState<string | undefined>(undefined)
  const [body, setBody] = useState(selectedAboutItem?.body)

  useEffect(() => {
    if (selectedAboutItem) {
      const {body, mainImage, images, title} = selectedAboutItem
      form.setFieldsValue({title, body})
      setMainImageId(mainImage)

      if (images?.length) {
        const files = selectedAboutItem?.images.map((imageId) => {
          return {
            uid: imageId,
            name: "",
            url: getImageLink({imageId: imageId, bucketId: BUCKETS.MAIN}),
            response: {$id: imageId}
          }
        })
        setUploadImages(files)
      }
    } else {
      form.resetFields()
    }

  }, [selectedAboutItem])


  const onMainImageSwitchChange = (props: { fileId: string, value: boolean }) => {
    const {fileId, value} = props
    if (!value) {
      setMainImageId(undefined)
    } else {
      setMainImageId(fileId)
    }
  }

  const customUploadItemRender = (originNode: ReactNode,
                                  file: UploadFile,
                                  fileList: UploadFile[],
                                  actions: {
                                    download: () => void;
                                    preview: () => void;
                                    remove: () => void;
                                  }
  ) => {
    return <span> {originNode} <Switch checked={file.response?.$id === mainImageId} onChange={(checked, event) => {
      onMainImageSwitchChange({fileId: file.response.$id, value: checked})

    }} size="small" checkedChildren="Головне" unCheckedChildren="Додаткове"/></span>
  }

  const okButtonHandler = async (formData: { body: string, title: string }) => {
    if (!uploadImages?.length) {
      showErrorNotification({message: "Будь ласка, додайте хоча б одне зображення."}); // move to messages enum and re-use
      return
    }
    if (!mainImageId) {
      showErrorNotification({message: "Будь ласка, оберіть головне зображення."}); // move to messages enum and re-use
      return
    }

    const data: AboutItem = {
      body: body || "",
      title: formData.title,
      mainImage: mainImageId,
      images: uploadImages.map((image) => image.response.$id)
    }
    await submitButtonHandler(data)
  }

  return <Spin spinning={isLoading}>
    <Form form={form} layout="vertical" className="about_form" onFinish={okButtonHandler}>
      <Form.Item label="Заголовок" name="title" rules={[{required: true, message: VALIDATION_MESSAGES.REQUIRED}]}>
        <Input/>
      </Form.Item>
      <Form.Item label="Текст" name="body">
        <TextEditor value={body} setValue={setBody}/>
      </Form.Item>
      <Form.Item label="Зображення" name="images">
        <Uploader files={uploadImages} setFiles={setUploadImages} customUploadItemRender={customUploadItemRender}
                  bucketId={BUCKETS.MAIN}/>
      </Form.Item>
    </Form>
  </Spin>

}

export default AboutForm